/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listExtensions} from '../api'

export const useMutationListExtensions = createReactQueryMutationHook('listExtensions', listExtensions)
